import type {
  BankAccountFragmentFragment,
  SubscriptionFragmentFragment,
} from '@graphql/react-apollo'

import { membershipIssues } from '@web-app/components/account/manage/membership/membershipState'
import { paymentAccountIssues } from '@web-app/components/payment-account-management/lib/accountHealth'

import type { AttentionIssue, AttentionSeverity } from './types'

const SEVERITY_RANK: Record<AttentionSeverity, number> = {
  critical: 2,
  warning: 1,
}

export function sortBySeverity(
  issues: ReadonlyArray<AttentionIssue>,
): AttentionIssue[] {
  return [...issues].sort(
    (a, b) => SEVERITY_RANK[b.severity] - SEVERITY_RANK[a.severity],
  )
}

// The worst on the list; null when nothing to do.
export function maxSeverity(
  issues: ReadonlyArray<AttentionIssue>,
): AttentionSeverity | null {
  return issues.reduce<AttentionSeverity | null>(
    (worst, issue) =>
      !worst || SEVERITY_RANK[issue.severity] > SEVERITY_RANK[worst]
        ? issue.severity
        : worst,
    null,
  )
}

// Every contributor in one place. Unloaded input contributes nothing.
export function resolveAttention({
  paymentAccounts,
  membership,
}: {
  paymentAccounts: ReadonlyArray<BankAccountFragmentFragment> | null | undefined
  membership: SubscriptionFragmentFragment | null
}): AttentionIssue[] {
  // Rails before membership: a dead card has to be fixed before a fee can be paid.
  return sortBySeverity([
    ...(paymentAccounts ? paymentAccountIssues(paymentAccounts) : []),
    ...membershipIssues(membership),
  ])
}
